import React, {useCallback, useContext, useEffect, useState} from "react";
import styles from "../components/SignUp/SignUp.module.css"
//Icon

// Validate

// Styles

import "react-toastify/dist/ReactToastify.css";
// Toast
import {ToastContainer} from "react-toastify";

//
import {Link} from "react-router-dom";
// Axios
import axios from "axios";
import {notify} from "../components/toast";
import {validate} from "../components/SignUp/validate"
import {axiosInstance} from "../utilities/AxiosConfig";
import Cookies from "js-cookie";
import {SpinnerContext, useSpinner} from "../context/SpinnerContext";
import {MunshiMenu} from "../components/Menu";
import {Button} from "primereact/button";
import {RadioButton} from "primereact/radiobutton";
import {Checkbox} from "primereact/checkbox";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {FloatLabel} from "primereact/floatlabel";
import {Password} from "primereact/password";
import {reset} from "next/dist/lib/picocolors";


const SignUp = ({handle}) => {

    const [department, setDepartment] = useState([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])

    const {loading, setLoading} = useSpinner()
    const [users, setUsers] = useState([]);
    const [database] = useState(Cookies.get('database') || "Test");
    const [newUser, setNewUser] = useState(false);
    const [selectedUser, setSelectedUser] = useState({id: 0, name: "Me"});
    const [passwords, setPasswords] = useState("")


    useEffect(() => {
        setLoading(true)
        axiosInstance.get(`/user/${database}`).then((response) => {
            setUsers(response.data.map((user) => {
                return {
                    id: user.id,
                    name: user.name,
                    department: user.department
                }
            }))
        }).catch((error) => {
            notify(error.message, "error")
        }).finally(
            () => {
                setLoading(false)
            }
        )
    }, [newUser])


    const onDepartmentChange = (e) => {
        let _department = [...department];
        _department[e] = _department[e] ===1 ?0:1;
        setDepartment(_department);

    }
    const CheckBox = () => {
        return (
            <>
                <div className={"flex flex-column justify-content-center align-items-center mt-2 w-full"}>
                    <div className="flex  justify-content-start gap-2 w-full">
                        <div className="flex align-items-center">
                            <Checkbox inputId="purchase" name="levalCheck" value={department[15]}
                                      className={"w-full"}
                                      onChange={() => onDepartmentChange(15)}
                                      checked={department[15] === 1}/>
                            <label htmlFor="purchase" className="ml-1 text-xs">Purchase</label>
                        </div>
                        <div className="flex align-items-center">
                            <Checkbox inputId="invoiceApproval" name="levalCheck" value={department[0]}
                                      className={"w-full"}
                                      onChange={() => onDepartmentChange(0)}
                                      checked={department[0] === 1}/>
                            <label htmlFor="invoiceApproval" className="ml-1 text-xs">Approval</label>
                        </div>
                        <div className="flex align-items-center">
                            <Checkbox inputId="invoiceReady" name="levalCheck" value={department[1]}
                                      className={"w-full"}
                                      onChange={() => onDepartmentChange(1)}
                                      checked={department[1] === 1}/>
                            <label htmlFor="invoiceReady" className="ml-1 text-xs">Ready</label>
                        </div>
                        <div className="flex align-items-center">
                            <Checkbox inputId="invoiceInvoiced" name="levalCheck" value={department[2]}
                                      className={"w-full"}
                                      onChange={() => onDepartmentChange(2)}
                                      checked={department[2] === 1}/>
                            <label htmlFor="invoiceInvoiced" className="ml-1 text-xs">Invoicing</label>
                        </div>
                        <div className="flex align-items-center">
                            <Checkbox inputId="invoiceDeliver" name="levalCheck" value={department[3]}
                                      className={"w-full"}
                                      onChange={() => onDepartmentChange(3)}
                                      checked={department[3] === 1}/>
                            <label htmlFor="invoiceDeliver" className="ml-1 text-xs">Delivery</label>
                        </div>
                        <div className="flex align-items-center">
                            <Checkbox inputId="posting" name="levelCheck" value={department[4]} className={"w-full"}
                                      onChange={() => onDepartmentChange(4)}
                                      checked={department[4] === 1}/>
                            <label htmlFor="posting" className="ml-1 text-xs">Posting</label>
                        </div>

                    </div>
                    <div className="flex  justify-content-start gap-2 mt-2 w-full">
                        <div className="flex align-items-center">
                            <Checkbox inputId="Ledger" name="levelCheck" value={department[5]} className={"w-full"}
                                      onChange={() => onDepartmentChange(5)}
                                      checked={department[5] === 1}/>
                            <label htmlFor="Ledger" className="ml-1 text-xs">Ledger</label>
                        </div>
                        <div className="flex align-items-center">
                            <Checkbox inputId="CashBookVouchers" name="levelCheck" value={department[5]}
                                      className={"w-full"}
                                      onChange={() => onDepartmentChange(6)}
                                      checked={department[6] === 1}/>
                            <label htmlFor="CashBookVouchers" className="ml-1 text-xs">CashBook/Vouchers</label>
                        </div>

                        <div className="flex align-items-center">
                            <Checkbox inputId="InventoryStock" name="levelCheck" value={department[7]}
                                      className={"w-full"}
                                      onChange={() => onDepartmentChange(7)}
                                      checked={department[7] === 1}/>
                            <label htmlFor="Inventory" className="ml-1  text-xs">Inventory/Stock</label>
                        </div>
                        <div className="flex align-items-center">
                            <Checkbox inputId="ReportAdmin" name="levelCheck" value={department[8]}
                                      className={"w-full"}
                                      onChange={() => onDepartmentChange(8)}
                                      checked={department[8] === 1}/>
                            <label htmlFor="ReportAdmin" className="ml-1 text-xs flex-nowrap">Report_Admin</label>
                        </div>

                    </div>
                    <div className="flex flex-wrap justify-content-start gap-3 mt-2 mb-4 w-full">
                        <div className="flex align-items-center">
                            <Checkbox inputId="UtilityAdmin" name="levelCheck" value={department[9]}
                                      className={"w-full"}
                                      onChange={() => onDepartmentChange(9)}
                                      checked={department[9] === 1}/>
                            <label htmlFor="UtilityAdmin" className="ml-1 text-xs">Utility_Admin</label>
                        </div>
                        <div className="flex align-items-center">
                            <Checkbox inputId="AfterSales" name="levelCheck" value={department[10]} className={"w-full"}
                                      onChange={() => onDepartmentChange(10)}
                                      checked={department[10] === 1}/>
                            <label htmlFor="AfterSales" className="ml-1 text-xs">After_Sales</label>
                        </div>
                        <div className="flex align-items-center">
                            <Checkbox inputId="Factory" name="levelCheck" value={department[11]} className={"w-full"}
                                      onChange={() => onDepartmentChange(11)}
                                      checked={department[11] === 1}/>
                            <label htmlFor="Factory" className="ml-1 text-xs">Factory</label>
                        </div>
                        <div className="flex align-items-center">
                            <Checkbox inputId="FactoryAdmin" name="levelCheck" value={department[12]}
                                      className={"w-full"}
                                      onChange={() => onDepartmentChange(12)}
                                      checked={department[12] === 1}/>
                            <label htmlFor="FactoryAdmin" className="ml-1 text-xs">Factory_Admin</label>
                        </div>
                        <div className="flex align-items-center">
                            <Checkbox inputId="Import" name="levelCheck" value={department[13]} className={"w-full"}
                                      onChange={() => onDepartmentChange(13)}
                                      checked={department[13] === 1}/>
                            <label htmlFor="Import" className="ml-1 text-xs">Import</label>
                        </div>
                        <div className="flex align-items-center">
                            <Checkbox inputId="All" name="levelCheck" value={department[14]} className={"w-full"}
                                      onChange={() => onDepartmentChange(14)}
                                      checked={department[14] === 1}/>
                            <label htmlFor="All" className="ml-1 text-xs">All</label>
                        </div>
                    </div>
                </div>
            </>
        )
    }


    const submitHandler = (event) => {
        event.preventDefault()
        const pushData = async () => {
            try {
                setLoading(true)
                const dep = department.toString()
                const response = await axiosInstance.post("/user/", {
                    id: selectedUser.id,
                    name: selectedUser.name,
                    password: passwords,
                    database: database,
                    department: dep,
                });
                if (response.data === 0) {
                    notify("You have already registered, log in to your account", "error")
                } else {
                    notify("You signed Up successfully", "success")
                }
            } catch (error) {
                notify(error.message, "error")
            } finally {
                setLoading(false)
                setNewUser(!newUser)
            }

        };
        pushData();


    };
    useEffect(() => {
        setSelectedUser({id: 0, name: ""})
        setPasswords("")
        setDepartment([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0])
    },[newUser])
    const handelDelete = () => {
        if (selectedUser.id === 0) {
            notify("Please select a user", "error")
            return;
        }
        const deleteUser = async () => {
            try {
                setLoading(true)
                const response = await axiosInstance.delete(`/user/${selectedUser.id}&${database}`);
                if (response.data === 1) {
                    notify("You have already registered, log in to your account", "error")
                }
                setNewUser(!newUser)
            } catch (error) {
                notify(error.message, "error")
            } finally {
                setLoading(false)
            }
        }
        deleteUser();

    }

    if (!loading && users) {
        return (
            <>
                <ToastContainer/>
                <MunshiMenu handle={handle}/>
                <div
                    className="container  flex flex-column justify-content-center align-items-center mt-6 w-fit h-full p-3 border-2 border-solid border-primary-subtle shadow rounded-5">
                    <div className={"text-3xl font-bold mb-2 text-primary"}>Sign Up</div>
                    <CheckBox/>
                    <div className={"flex flex-column justify-content-center align-items-center mt-2 w-full"}>
                        <div className={"flex justify-content-start align-items-center w-full mb-2"}>
                            {!newUser &&
                                <>
                                    <Button icon="pi pi-file-plus" className={"mr-2 "} onClick={() => {
                                        setNewUser(!newUser)
                                    }}/>
                                    <Button icon="pi pi-trash" className={"mr-2 "} onClick={handelDelete}/>
                                    <Dropdown value={selectedUser.id} options={users} optionLabel="name"
                                              optionValue="id"
                                              className={"flex w-full justify-content-center align-items-center "}
                                              onChange={(e) => {
                                                  e.preventDefault()
                                                  setSelectedUser({
                                                      id: e.value,
                                                      name: users.find((user) => user.id === e.value).name
                                                  });
                                                  setDepartment(users.find((user) => user.id === e.value).department.split(",").map((it) => parseInt(it)))
                                              }

                                    }/>
                                </>}
                            {newUser &&
                                <>
                                    <Button icon="pi pi-wrench" className={"mr-2 "} onClick={() => {
                                        setNewUser(!newUser)
                                    }}/>
                                    <FloatLabel>
                                        <InputText value={selectedUser.name}
                                                   className={"flex w-full justify-content-center align-items-center "}
                                                   id="name"
                                                   onChange={(e) => setSelectedUser({id: 0, name: e.target.value})}
                                                   autoComplete="off"/>
                                        <label htmlFor="name">User Name</label>
                                    </FloatLabel>
                                </>}
                        </div>
                        <div className={"flex justify-content-start align-items-center w-full mb-2 ml-7"}>
                            <FloatLabel>
                                <Password value={passwords} id="pwd" onChange={(e) => setPasswords(e.target.value)}
                                          className={"pl-4"}

                                          toggleMask/>
                                <label className={"pl-4"} htmlFor="pwd">Password</label>
                            </FloatLabel>
                        </div>
                        <div className="container flex justify-content-center align-items-center w-full mt-2 ml-2">
                            <Button label="Submit" icon="pi pi-check" className={" h-2rem"} onClick={submitHandler}/>
                        </div>
                    </div>
                </div>


            </>
        )
            ;
    }
};

export default SignUp;